/**
 * Bind element with the gloId data attribute
 */
import $ from 'jquery'
import { trace } from 'rytm-helpers'

const SELECTOR = "*[data-glo-id]"
const CLASS_NAME_ACTIVE = "glo-id-active"

const clearAll = () => {
  const list = [...document.querySelectorAll(SELECTOR)]
  list.forEach((el) => {
    el.classList.remove(CLASS_NAME_ACTIVE)
  })
}
const onGloIdMouseEnter = (e) => {
  clearAll()
  const trigger = e.currentTarget
  const id = trigger.dataset.gloId
  if (id) {
    const list = [...document.querySelectorAll('*[data-glo-id="' + id + '"]')]
    list.forEach((el) => {
      el.classList.add(CLASS_NAME_ACTIVE)
    })
  }
}
const onGloIdMouseLeave = (e) => {
  clearAll()
}

export const initGloId = () => {
  $("body").on("mouseenter", SELECTOR, onGloIdMouseEnter)
  $("body").on("mouseleave", SELECTOR, onGloIdMouseLeave)
}